export const focusSelect = (inputCurrent) => {
	inputCurrent.focus();
	setTimeout(function () {
		inputCurrent.select();
	});
};

export const getMlsFormProps = (theme) => {
	return {
		/* dialog content */
		dialogContent: {
			overflow: 'visible'
		},		

		dialogTitle: {
			'& h6': {
				fontWeight: 600,
				fontSize: '28px',
				lineHeight: 1.4,
				marginBottom: 10,
				textAlign: 'left',
				display: 'flex',
				alignItems: 'center'
			}
		},
		headerIcon: {
			marginRight: 10
		},
		headerIconInfo: {
			color: '#6F99BD'
		},

		/* close dialog */
		closeDialog: {
			position: 'absolute',
			top: 10,
			right: 10
		},
		closeDialogIcon: {
			color: '#6F99BD',
			width: '20px',
			height: '20px'
		},		

		/* input field */
		field: {
			width: '100%',
			margin: 0,

			'& input, & textarea': {
				border: '1px solid #aabfd1',
				borderStyle: 'solid',
				borderRadius: 5,
				color: theme.palette.text.primary,
				padding: '10px',
				'&:focus, &:hover': {
					color:'#2888c3',
					borderColor:'#2888c3'
				},

				'&::placeholder': {
					fontFamily: 'Open Sans, sans-serif',
					fontWeight: 'normal',
					fontStyle: 'normal',
					fontSize: '14px',
					lineHeight: '19px',
					color: theme.palette.text.primary
				}
			},

			'& textarea': {
				width: '425px',
				display: 'block',
			},

			'& [id*=helper-text]': {
				paddingLeft: 0,
				color: theme.palette.error.main
			},

			'& [class*=error] input': {
				borderColor: `${theme.palette.error.main} !important`
			}
		},

		/* radio button */
		radioGroupLabel: {
			margin: '8px 0 2px',
		},

		radioGroupContainer: {
			marginBottom: 16,
		},
		radioSelectorLabel: {
			'& span': {
				opacity: 1,
				fontSize: 16,
				lineHeight: 1,
			}
		},
		radioSelectorLabelChecked: {
			'& span': {
				color: '#2fa5e7',
				fontSize: 16,
				lineHeight: 1,
				'&[class*=MuiFormControlLabel-label]': {
					color: '#000'
				}
			},
		},
		radioSelectorLabelHover: {
			'&:hover span': {
				color: '#2888c3 !important'
			}	
		},
		radioButton: {
			root: {
				'&$checked': {
					color: '#2FA5E7'
				}
			},
			checked: {},
		},		

		/* text field */
		textFieldWrapper: {
			width: '100%',
			paddingBottom: 12
		},
		textFieldWrapperError: {
			'& input': {
				borderColor: `${theme.palette.error.main} !important`,
			}
		},
		formFieldLabel: {
			display: 'block',
			textAlign: 'left',
			color: theme.palette.text.primary,
			opacity: 1,
			margin: '0 0 10px',
		},

		/* submit button */
		buttonsContainer: {
			paddingBottom: 10,
			'& button:not(:first-child)': {
				marginLeft: 8
			}
		},
		button: {
			fontFamily: 'Open Sans, sans-serif',
			borderRadius: 5,
			fontWeight: 600,
			fontSize: 18,
			lineHeight: 1.3,
			opacity: '1 !important'
		},
		buttonPrimary: {
			background: theme.palette.primary.main,
			color: 'white',
			textShadow: 'none',
			paddingLeft: 10,
			paddingRight: 15,
			'&[class*=contained][class*=disabled]': {
				backgroundColor: '#f4f4f4',
				color: '#4a5660'
			}
		},

		/* links */
		linksContainer: {
			textAlign: 'left',
			padding: '30px 0 0'
		},
		link: {
			'&:first-child': {
				marginBottom: 18
			}
		},

		/* error message */
		error: {
			color: `${theme.palette.error.main} !important`,
			paddingLeft: '0  !important',
		},
		errorMessage:  {
			color: theme.palette.error.main,
			fontSize: 14,
			lineHeight: 1.5,
			opacity: 1,
			textAlign: 'left',
			marginTop: -15,
			marginBottom: 15,
			'& a': {
				color: theme.palette.primary.main
			}
		},		

		/* loading */
		loadingContent: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)'
		},
		loadingMessage: {
			fontSize: 16,
			lineHeight: 1.5,
			opacity: 1
		},
		loadingIcon: {
			display: 'block',
			height: '24px',
			width: '24px',
			margin: '0 auto 10px',
			fill: '#96DCFD',
			animation: 'spin 2s linear infinite'
		},
		'@keyframes spin': {
			'0': {
				transform: 'rotate(0deg)'
			},
			'100%': {
				transform: 'rotate(360deg)'
			}
		},
		
		/* form message */
		formMessage: {
			textAlign: 'left',
			'& p:not(:last-child)': {
				marginBottom: 20
			},
			'& p': {
				fontSize: '16px',
				lineHeight: '22px',
				opacity: 1
			}
		},

		feedbackMessage: {
			textAlign: 'left',
			'& p:not(:last-child)': {
				marginBottom: 20
			},
			'& p': {
				fontSize: '16px',
				lineHeight: '22px',
				opacity: 1
			}
		},

		/* misc */
		noMargins: {
			margin: 0
		},		
	};
};



// WEBPACK FOOTER //
// ./src/utils/forms.js